import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { useTreatments } from '@splitsoftware/splitio-react'
import React, { useState } from 'react'
import { useTimeout } from 'react-use'
import { object, string } from 'yup'

import { useForm } from '../../utils/form/useForm'
import { cleanString } from '../../utils/helpers'
import GoogleAnalyticsHiddenFields from '../GoogleAnalyticsHiddenFields'
import Link from '../Link'
import NewsletterSignupNew from '../NewsletterSignupNew'
import Button from '../UI/Button/Button'
import Wrapper from '../UI/Wrapper'
import { NewsletterSection, StyledContainer } from './styles'

const NewsletterSignup = (props: any) => {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const { content, className = '' } = props

  const initialValues = {
    subscribeEmail: '',
  }

  const emailError = cleanString(content?.error_message?.[0]?.copy)

  const validationSchema = () =>
    object().shape({
      subscribeEmail: string().required(emailError).email(emailError),
    })

  const formId = 'subscribeForm'

  const form = useForm({
    initialValues,
    formId,
    endpoint: 'newsletter',
    validationSchema,
    onSuccess: () => {
      setIsSubmitted(true)
    },
    mapper: ({ subscribeEmail }) => ({
      email: subscribeEmail,
    }),
    emailField: 'subscribeEmail',
  })

  return (
    <NewsletterSection className={className}>
      <Wrapper>
        <Typography
          className="headline"
          color="inherit"
          component="h2"
          variant="h3"
        >
          {content?.headline}
        </Typography>
        <Typography
          className="body"
          color="inherit"
          component="p"
          variant="body1"
        >
          {content?.short_description}
        </Typography>
        <form
          className="subscribeForm"
          id="subscribeForm"
          onSubmit={form.handleSubmit}
        >
          {isSubmitted ? (
            <StyledContainer>
              <Typography className="successMessage" component="p" variant="h2">
                {content?.confirmation_message?.[0]?.copy
                  ? cleanString(content?.confirmation_message?.[0]?.copy)
                  : null}
              </Typography>
            </StyledContainer>
          ) : (
            <StyledContainer>
              <GoogleAnalyticsHiddenFields />
              <TextField
                className="subscribeEmail"
                error={
                  form.touched.subscribeEmail
                    ? Boolean(form.errors.subscribeEmail)
                    : null
                }
                helperText={
                  form.touched.subscribeEmail
                    ? form.errors.subscribeEmail
                    : null
                }
                id="subscribeEmail"
                label={cleanString(content?.first_name_label?.[0]?.copy)}
                name="subscribeEmail"
                onChange={form.handleChange}
                value={form.values.subscribeEmail}
                variant="filled"
              />
              <Button type="submit" variant="secondary">
                {content?.submit_cta?.[0]
                  ? cleanString(content?.submit_cta?.[0]?.copy)
                  : 'Subscribe'}
              </Button>
              <Typography
                className="mouseType"
                component="span"
                variant="caption"
              >
                <Link link={content?.small_text?.[0]}>
                  {content?.small_text?.[0]?.text}
                </Link>
              </Typography>
            </StyledContainer>
          )}
        </form>
      </Wrapper>
    </NewsletterSection>
  )
}

const NewsletterSignupSplitTest = (props: any) => {
  const showEmailOnlyForm = useTreatments(['DOWNLOAD_FORM_EMAIL_ONLY'])

  // give a small timeout to lookup the split.io value before rendering
  // (if split.io lookup fails, then treatment value will come as "control"
  // instead of on/off and will still render the red variant of the form)
  const [isReady] = useTimeout(500)
  if (!isReady) {
    return null
  }

  if (showEmailOnlyForm.DOWNLOAD_FORM_EMAIL_ONLY.treatment?.startsWith('on')) {
    return <NewsletterSignupNew {...props} />
  }

  return <NewsletterSignup {...props} />
}
export default NewsletterSignupSplitTest
